/**
 * component for rendering a basic announcement modal
 * @file AnnouncementModal
 * @author Julius Diaz Panoriñgan
 */

import { Button, Col, Modal, Row } from 'antd'
import React from 'react'

import './AnnouncementModal.less'

/**
 * @function AnnouncementModal
 * @param {React.ReactElement|string} props.content
 * @param {function} props.dismiss
 * @param {React.ReactElement|string} props.title
 * @returns {React.ReactElement}
 */
const AnnouncementModal = ({ content, dismiss, title }) => (
  <Modal
    className='announcement-modal'
    closable={false}
    footer={null}
    title='Announcements'
    visible
  >
    <h2>{title}</h2>
    <div>{content}</div>
    <Row type='flex' gutter={16} justify='center'>
      <Col>
        <Button type='primary' onClick={dismiss}>
          Got it!
        </Button>
      </Col>
    </Row>
  </Modal>
)

// AnnouncementModal.propTypes = {}

export default AnnouncementModal
